import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootPrintApiManager_ds_get_orders_without_shipmentsService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: {  }): 
  Promise<{ result: { Id?: number, LookupCode?: string, OrderStatusId?: number, PreferredCarrierId?: number, PreferredWarehouseId?: number, ProjectId?: number, RequestedDeliveryDate?: string, OrderLines?: { LineNumber?: number }[], OrderClass?: { OrderTypeId?: number } }[] }> 
  {
    let url = `${environment.backendUrl}api/FootPrintApiManager/datasources/ds_get_orders_without_shipments/get`;
    
    const options = {
    }
    
    const body = null;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, OrderStatusId?: number, PreferredCarrierId?: number, PreferredWarehouseId?: number, ProjectId?: number, RequestedDeliveryDate?: string, OrderLines?: { LineNumber?: number }[], OrderClass?: { OrderTypeId?: number } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/FootPrintApiManager/datasources/ds_get_orders_without_shipments/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, OrderStatusId?: number, PreferredCarrierId?: number, PreferredWarehouseId?: number, ProjectId?: number, RequestedDeliveryDate?: string, OrderLines?: { LineNumber?: number }[], OrderClass?: { OrderTypeId?: number } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/FootPrintApiManager/datasources/ds_get_orders_without_shipments/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

